import $ from 'jquery';

// Touch/No Touch Device
if (!("ontouchstart" in document.documentElement)) {
    document.documentElement.className += "no-touch";
} else {
  document.documentElement.className += "touch";
}

// Replace all SVG images with inline SVG
$('img.svg').each(function() {
    var $img = jQuery(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    jQuery.get(imgURL, function(data) {
        // Get the SVG tag, ignore the rest
        var $svg = jQuery(data).find('svg');
        // Add replaced image's ID to the new SVG
        if(typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if(typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass+' replaced-svg');
        }
        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');
        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
        if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
            $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
        }
        // Replace image with new SVG
        $img.replaceWith($svg);
    }, 'xml');
});

const Util = {
  // Exactly the same as foundation's transitionend but allowing to skip the
  // trigger.
  transitionend($elem, trigger) {
    var transitions = {
      'transition': 'transitionend',
      'WebkitTransition': 'webkitTransitionEnd',
      'MozTransition': 'transitionend',
      'OTransition': 'otransitionend'
    };
    var elem = document.createElement('div'),
        end;

    for (var t in transitions){
      if (typeof elem.style[t] !== 'undefined'){
        end = transitions[t];
      }
    }
    if (end) {
      return end;
    }
    else {
      if (false !== trigger) {
        end = setTimeout(function(){
          $elem.triggerHandler('transitionend', [$elem]);
        }, 1);
      }
      return 'transitionend';
    }
  },

  raf() {
    return window.requestAnimationFrame  ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame    ||
      function (callback) {
        window.setTimeout(callback, 1000 / 60);
      };
  },

  nextTick(fn) {
    setTimeout(fn, 0);
  },

  setRafTimeout(fn, delay) {
    const timer = Date.now();
    const raf = Util.raf();
    let elapsed;

    const frame = function () {
      elapsed = Date.now() - timer;
      if (elapsed < delay) {
        raf(frame);
      } else {
        fn.call();
      }
    };

    raf(frame);
  },

  throttle(fn, delay) {
    let timer = null;
    let elapsed;
    const raf = Util.raf();

    const frame = function () {
      elapsed = Date.now() - timer;
      if (elapsed < delay) {
        raf(frame.bind(this));
      } else {
        timer = null;
      }
    };

    return function () {
      if (timer === null) {
        timer = Date.now();
        fn.apply(this, arguments);
        raf(frame.bind(this));
      }
    };
  },

  scrollTo(target, options={}) {
    let scrollTop;
    const resolved = $.when();

    options = $.extend({}, {
      duration: 1000,
      offset: 0,
      easing: 'swing'
    }, options);

    // if target is not a number assume it is a selector, an element, or a jquery
    // wrapped element (all of which are turned into an element by $(...))
    if (isNaN(target)) {
      scrollTop = $(target).offset();
      scrollTop = scrollTop && scrollTop.top;
    } else {
      scrollTop = target;
    }

    // now if y is not a number, something went wrong (fail silently?)
    if (isNaN(scrollTop)) {
      return $.when();
    }

    // account for fixed header, etc
    scrollTop -= options.offset;

    // resolve immediately if there's no scrolling to do.
    if ($(window).scrollTop() == scrollTop) {
      return resolved;
    }

    if (0 == options.duration) {
      $(window).scrollTop(scrollTop);
      return resolved;
    }

    return $('html, body').animate(
      { scrollTop: scrollTop },
      options.duration,
      options.easing
    ).promise();
  }
}

export default Util;
